var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Education post",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "120px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.title,
      callback: function ($$v) {
        _vm.$set(_vm.item, "title", $$v);
      },
      expression: "item.title"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Post Type",
      "required": ""
    }
  }, [_c('el-select', {
    model: {
      value: _vm.item.post_type,
      callback: function ($$v) {
        _vm.$set(_vm.item, "post_type", $$v);
      },
      expression: "item.post_type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "video",
      "label": "Video (YouTube)"
    }
  }), _c('el-option', {
    attrs: {
      "value": "link",
      "label": "Link"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Audience",
      "required": ""
    }
  }, [_c('el-select', {
    model: {
      value: _vm.item.audience,
      callback: function ($$v) {
        _vm.$set(_vm.item, "audience", $$v);
      },
      expression: "item.audience"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "designers",
      "label": "Designers"
    }
  }), _c('el-option', {
    attrs: {
      "value": "developers",
      "label": "Developers"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Thumbnail"
    }
  }, [_vm.item.thumb_url ? _c('img', {
    attrs: {
      "src": _vm.item.thumb_url,
      "height": "100px",
      "width": "auto"
    }
  }) : _vm._e(), _c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.item.thumb_url,
      callback: function ($$v) {
        _vm.$set(_vm.item, "thumb_url", $$v);
      },
      expression: "item.thumb_url"
    }
  }), _c('el-upload', {
    attrs: {
      "on-success": _vm.onUploadSuccess,
      "data": _vm.data,
      "headers": _vm.headers,
      "accept": "image/*",
      "action": _vm.action,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("Upload")])], 1), _vm.item.thumb_url ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "default"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Remove")]) : _vm._e()], 1), _c('el-form-item', {
    attrs: {
      "label": "Tag",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.tag,
      callback: function ($$v) {
        _vm.$set(_vm.item, "tag", $$v);
      },
      expression: "item.tag"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.item.post_type === 'video' ? 'YouTube ID' : 'URL',
      "required": ""
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.modifySrc
    },
    model: {
      value: _vm.item.src,
      callback: function ($$v) {
        _vm.$set(_vm.item, "src", $$v);
      },
      expression: "item.src"
    }
  }, [_vm.item.post_type === 'video' ? _c('template', {
    slot: "prepend"
  }, [_vm._v("https://youtu.be/")]) : _vm._e()], 2), _vm._v(" (You may also simply paste short YouTube URL here.) ")], 1), _c('el-form-item', {
    attrs: {
      "label": "Published",
      "required": ""
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.item.is_published,
      callback: function ($$v) {
        _vm.$set(_vm.item, "is_published", $$v);
      },
      expression: "item.is_published"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }